import React from "react";

import Conditional from "../../../common/conditional";
import CustomSection from "../custom-section";
import Image from "../../../blocks/report-image/image";

import { ICertificate } from "./form";
import { getOptimizedImageURL } from "../../../../utils/utilities";

import classNames from "./style.module.scss";
import config from "../../../../utils/config";

interface Props {
    certificates: ICertificate;
}

const CustomCertificatePdf: React.FC<Props> = ({ certificates }) => {
    return (
        <React.Fragment>
            {certificates.training.map((training) => (
                <CustomSection key={training.refNo} sectionTitle="Certificates" sectionSubtitle="Inspector NDT Level 2 Certificate">
                    <div className="p-1">
                        <Conditional isVisible={config.requireImagesToPublish}>
                            <Image src={getOptimizedImageURL(training.src)} alt={training.caption}/>
                        </Conditional>
                    </div>
                </CustomSection>
            ))}
            
            <Conditional isVisible={certificates.calibration.length > 0}>
                {certificates.calibration.map((calibration) => (
                    <CustomSection key={calibration.refNo} sectionTitle="Certificates" sectionSubtitle="Equipment Calibration Certificate">
                        <div className="p-1">
                            <Conditional isVisible={config.requireImagesToPublish}>
                                <div className={classNames.certificateImage}>
                                    <Image src={getOptimizedImageURL(calibration.src)} alt={calibration.caption}/>
                                </div>
                            </Conditional>
                        </div>
                    </CustomSection>
                ))}
            </Conditional>
        </React.Fragment>
    )
};

export default CustomCertificatePdf;
